module.exports = __webpack_public_path__ + "static/media/normal.abaa81bd.svg";